<h1 class="pageTitle">Create Account</h1>
<form [formGroup]="profileQuestionForm" (ngSubmit)="onSubmit()">
    <div class="content with-action">
        <div class="row" *ngIf="questionId == '1'">
            <div class="alert alert-warning" role="alert">
                <h4>Are you a BJC West Region (Saint Luke's) employee?</h4>
                <p>Please answer "No" to the question below to proceed with account creation.</p>
            </div>
            <div class="col-md-12">
                <h2 class="subtitle">Are you a BJC East Region employee?</h2>
                <div class="options">
                    <!-- Default unchecked -->
                    <div class="form-check">
                        <input type="radio" class="form-check-input" formControlName="answer" value="yes" id="foryes" name="answer">
                        <label class="form-check-label font14" for="foryes">Yes</label>
                    </div>

                    <!-- Default checked -->
                    <div class="form-check">
                        <input type="radio" class="form-check-input" formControlName="answer" value="no" id="forno" name="answer">
                        <label class="form-check-label font14" for="forno">No</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="questionId == '2'">
            <div class="col-md-12">
                <h2 class="subtitle">Are you enrolled in the BJC Medical Plan and are the primary plan member?</h2>
                <div class="options">
                    <!-- Default unchecked -->
                    <div class="form-check">
                        <input type="radio" class="form-check-input" formControlName="answer" value="yes" id="foryes" name="answer">
                        <label class="form-check-label font14" for="foryes">Yes</label>
                    </div>
                    <!-- Default checked -->
                    <div class="form-check">
                        <input type="radio" class="form-check-input" formControlName="answer" value="no" id="forno" name="answer">
                        <label class="form-check-label font14" for="forno">No</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row action m-0" [ngClass]="{'slide-left-action':slideScreen}">
        <div class="col-lg-3 col-md-6 p-0">
            <button type="submit" class="btn btn-enable btn-block" [disabled]="!profileQuestionForm.valid">CONTINUE</button>
        </div>
    </div>
</form>